export enum NewsFiltersOptions {
    Date = 'Date',
    Company = 'Company',
}
